import {
  BrowserModule,
} from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AppComponent } from './app.component';
import { AppRoutingModule, SelectivePreloadingStrategy } from './app.routing';
import { AppService } from './app.service';
import { ApiService } from './services/api.service';
import { ApiRepository } from './services/api-repository';
import { RouteHistoryService } from './services/setGetRouteHistory.service';
import { MessageService } from './services/message.service';
import { SessionService } from './services/session.service';
import { LoaderService } from './services/loader.service';
import { AppStartService } from './services/app-start.service';
import { ExternalLibService } from './services/set-external-lib.service';
// import {
//   OtherWorkflowGuard
// } from './guards/logisticGuard.service';
import { LoadGuard } from './guards/load.guard';
import { ThemeService } from './services/theme.service';
import { MarketplaceGuardService } from './guards/marketplace-guard.service';
import { PopupModule } from './modules/popup/popup.module';
import { ModalModule } from './components/modal/modal.module';
import { OrderWithAiModule } from './modules/order-with-ai/order-with-ai.module';
import { GoogleAnalyticsEventsService } from './services/google-analytics-events.service';
import { SeoService } from './services/seo.service';
import { SeoGuard } from './guards/seo.guard';
import { ProfileService } from './components/profile/profile.service';
import { CookieFooterModule } from './components/cookie-setting-footer/cookie-setting-footer.module';
import { FBPixelService } from './services/fb-pixel.service';
import { OrdersService } from './components/orders/orders.service';
import { PopUpService } from './modules/popup/services/popup.service';
import { GoogleAdWordsService } from './services/google-adwords.service';
import { TransferHttpCacheModule } from '@nguniversal/common';
// import { TransferHttpCacheModule } from '@hapiness/ng-universal-transfer-http';
import { environment } from '../environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { GoogleMapsConfig } from './services/googleConfig';
import { RestaurantGuard } from './guards/restaurant.guard';
import { CommonService } from './services/common.service';
import { BusinessCategoriesService } from './components/restaurants-new/components/business-categories/business-categories.service';
import { JwNotificationsModule } from './modules/jw-notifications/jw-notifications.module';
import { registerLocaleData } from '@angular/common';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
import {
  OKTA_CONFIG,
  OKTA_AUTH
} from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
defineLocale('es', esLocale);

import localeEn from '@angular/common/locales/en'; 
import localeAr from '@angular/common/locales/ar'; 
import localeEs from '@angular/common/locales/es'; 
import localePt from '@angular/common/locales/pt'; 
import localeFr from '@angular/common/locales/fr';
import localeMs from '@angular/common/locales/ms';
import localeBn from '@angular/common/locales/bn';
import localeKm from '@angular/common/locales/km';
import localeKa from '@angular/common/locales/ka';
import localeRo from '@angular/common/locales/ro';
import localeTa from '@angular/common/locales/ta';
import localeSi from '@angular/common/locales/si';
import localeSv from '@angular/common/locales/sv';
import localeNl from '@angular/common/locales/nl';
import localeEl from '@angular/common/locales/el';
import localeKo from '@angular/common/locales/ko';
import localeTh from '@angular/common/locales/th';
import localeMr from '@angular/common/locales/mr';
import localeHi from '@angular/common/locales/hi';
import localeRu from '@angular/common/locales/ru';
import localeIt from '@angular/common/locales/it';
import localeHr from '@angular/common/locales/hr';
import localeLv from '@angular/common/locales/lv';
import localeTr from '@angular/common/locales/tr';
import localeNb from '@angular/common/locales/nb';
import localeLo from '@angular/common/locales/lo';
import localeVi from '@angular/common/locales/vi';
import localeHu from '@angular/common/locales/vi';
import localeDe from '@angular/common/locales/vi';
import localeSk from '@angular/common/locales/sk';
import localeKn from '@angular/common/locales/kn';
import localeZhHans from '@angular/common/locales/zh-Hans';
import localeZhHant from '@angular/common/locales/zh-Hans';
import localeHe from '@angular/common/locales/he';
import localeJa from '@angular/common/locales/ja';
import localeBs from '@angular/common/locales/bs';
import localeMk from '@angular/common/locales/mk';
export function oktaConfigFactory(sessionService: SessionService) {
  const oktaConfig = {
    clientId: sessionService.get('config').okta_client_id,
    issuer: sessionService.get('config').okta_domain,
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    testing: {
      disableHttpsCheck: false,
    },
  };
  return sessionService.get('config').okta_sso_enabled ? oktaConfig : null;
}
export function oktaAuthFactory(sessionService: SessionService) {
  const oktaConfig = {
    clientId: sessionService.get('config').okta_client_id,
    issuer: sessionService.get('config').okta_domain,
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    testing: {
      disableHttpsCheck: false,
    },
  };
  const oktaAuth = new OktaAuth(oktaConfig);
  return sessionService.get('config').okta_sso_enabled ? oktaAuth : null;
}

const locale = [{label: '/ar/',locale : localeAr},
                {label: '/ar-kl/',locale : localeAr},
                {label: '/ar-sa/',locale : localeAr },
                {label: '/bn/',locale : localeBn },
                {label: '/de/',locale : localeDe },
                {label: '/el/',locale : localeEl },
                {label: '/en/',locale : localeEn },
                {label: '/es-mx/',locale : localeEs},
                {label: '/es/',locale : localeEs },
                {label:'/fr-ch/',locale:localeFr },
                {label: '/fr/' ,locale: localeFr },
                {label: '/hi/',locale : localeHi },
                {label: '/hr/',locale : localeHr },
                {label: '/hu/',locale : localeHu },
                {label: '/it/',locale : localeIt },
                {label: '/ka/',locale : localeKa },
                {label: '/km/',locale : localeKm },
                {label: '/kn/',locale : localeKn },
                {label: '/ko/',locale : localeKo },
                {label: '/lo/',locale : localeLo },
                {label: '/lv/',locale : localeLv },
                {label: '/mr/',locale : localeMr },
                {label: '/ms/',locale : localeMs },
                {label: '/nb/',locale : localeNb },
                {label: '/nl/',locale : localeNl },
                {label: '/pt-br/',locale : localePt},
                {label: '/pt/',locale : localePt },
                {label: '/ro/',locale : localeRo },
                {label: '/ru/',locale : localeRu },
                {label: '/si/',locale : localeSi },
                {label: '/sk/',locale : localeSk },
                {label: '/sv/',locale : localeSv },
                {label: '/ta/',locale : localeTa }, 
                {label: '/th/',locale : localeTh },
                {label: '/tr/',locale : localeTr },
                {label: '/vi/',locale : localeVi },               
                {label: '/ku/',locale : localeEn },
                {label: '/zh-Hans/',locale:localeZhHans },
                {label: '/zh-Hant/',locale:localeZhHant },
                {label: '/he/' , locale:localeHe},
                {label: '/ja/',locale : localeJa},
                {label:'/bs/',locale:localeBs}, 
                {label:'/mk/',locale:localeMk}, 
                {label: '/customLang1/' , locale:localeEn},
                {label: '/customLang2/' , locale:localeEn},
                {label: '/customLang3/' , locale:localeEn},
                {label: '/customLang4/' , locale:localeEn},
                {label: '/l1/' , locale:localeEn},
                {label: '/l2/' , locale:localeEn},
                {label: '/l3/' , locale:localeEn},
                {label: '/l4/' , locale:localeEn}            
];
  locale.forEach((element)=>{
    if(element.label == window['base-href'])
    {
      registerLocaleData(element.locale,element.label.split('/')[1]);
    }
  });

export function appStartFactory(appStartService: AppStartService): Function {
  return () => appStartService.initialLoad();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
BrowserAnimationsModule,
HttpClientModule,
TransferHttpCacheModule,
BsDatepickerModule.forRoot(),
TooltipModule.forRoot(),
AppRoutingModule,
CookieFooterModule,
PopupModule,
JwNotificationsModule,
ModalModule,
OrderWithAiModule,
ServiceWorkerModule.register('ngsw-worker.js', {
enabled: environment.beta || environment.production
})
  ],
  providers: [
    ExternalLibService,
    AppService,
    AppStartService,
    {
      // Provider for APP_INITIALIZER
      provide: APP_INITIALIZER,
      useFactory: appStartFactory,
      deps: [AppStartService],
      multi: true
    },
    {
      provide: APP_BASE_HREF,
      useValue: window['base-href']
    },
    {
      provide: OKTA_CONFIG,
      useFactory: oktaConfigFactory,
      deps: [SessionService]
    },
    {
      provide: OKTA_AUTH,
      useFactory: oktaAuthFactory,
      deps: [SessionService]
    },
    RouteHistoryService,
    ApiService,
    ApiRepository,
    OrdersService,
    CommonService,
    PopUpService,
    MessageService,
    SessionService,
    LoaderService,
    SelectivePreloadingStrategy,
    MarketplaceGuardService,
    LoadGuard,
    RestaurantGuard,
    ThemeService,
    GoogleAnalyticsEventsService,
    SeoService,
    SeoGuard,
    ProfileService,
    FBPixelService,
    GoogleMapsConfig,
    GoogleAdWordsService,
    BusinessCategoriesService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}